import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {
  Icon,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(({ palette }) => ({
  icon: { minWidth: 36, '& .material-icons': { fontSize: 20 } },
  danger: { color: palette.error.main },
}))

/**
 * A "⋮" button listing actions. Each action is
 * `{ key, label, icon, onClick?, to?, danger? }`: `to` renders a router
 * link, `onClick` is called after the menu closes.
 */
const ActionsMenu = ({ actions, label = 'Ações', icon = 'more_vert' }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  if (!actions?.length) return null

  const close = () => setAnchorEl(null)

  return (
    <>
      <IconButton
        size="small"
        className="t-actions-menu"
        aria-label={label}
        aria-haspopup="menu"
        onClick={(e) => {
          e.stopPropagation()
          setAnchorEl(e.currentTarget)
        }}
      >
        <Icon>{icon}</Icon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={close}
        onClick={(e) => e.stopPropagation()}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {actions.map((action) => {
          const linkProps = action.to ? { component: Link, to: action.to } : {}
          return (
            <MenuItem
              key={action.key}
              {...linkProps}
              className={action.danger ? classes.danger : undefined}
              onClick={() => {
                close()
                action.onClick?.()
              }}
            >
              <ListItemIcon
                className={`${classes.icon} ${
                  action.danger ? classes.danger : ''
                }`}
              >
                <Icon>{action.icon}</Icon>
              </ListItemIcon>
              <ListItemText primary={action.label} />
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}

export default ActionsMenu
